import * as Sentry from "@sentry/vue";

// Input the backend rejected and the user already sees as a message, not a bug. Errors without
// a code are kept: a non-null violation carries none, and it is a bug.
const isValidationError = ({ extensions }) => extensions?.code === "VALIDATION_ERROR";

export const isValidationOnly = (graphQLErrors) => graphQLErrors.length > 0 && graphQLErrors.every(isValidationError);

// Apollo hands the error link a plain ErrorResponse object, not an Error. Capturing it
// as-is makes Sentry title every backend failure "Object captured as exception with
// keys: ..." and group them all under the minified callback, so unrelated bugs share a
// single issue. Wrapping it in a real Error and fingerprinting on operation plus backend
// message gives one issue per actual failure.
export function captureGraphQLError(error) {
  const operationName = error.operation?.operationName || "unknown";
  const graphQLErrors = error.graphQLErrors || [];

  if (isValidationOnly(graphQLErrors)) return;

  // Validation text embeds dates, so a crash next to it must not be fingerprinted on it.
  const reported = graphQLErrors.filter((graphQLError) => !isValidationError(graphQLError));
  const messages = reported.map(({ message }) => message);
  const message = messages.join("\n") || error.networkError?.message || error.message || "Unknown Apollo error";

  const captured = new Error(message);
  captured.name = "GraphQLError";

  // Variables are deliberately left out — they carry CPR numbers and other personal data.
  Sentry.captureException(captured, {
    fingerprint: ["graphql", operationName, messages[0] || message],
    tags: { graphqlOperation: operationName },
    extra: {
      operationName,
      graphQLErrors: reported.map(({ message, path, extensions }) => ({ message, path, code: extensions?.code })),
    },
  });
}
